import { ActionReducerMapBuilder, createSlice } from '@reduxjs/toolkit';
import { getErrorCodeFromMessage, getErrorMessageFromMessage } from '../slice';
import { receiveCredentials, startPresentationExchange } from './PresentationExchangeApi';
import { AsyncThunk } from '@reduxjs/toolkit/src/createAsyncThunk';
import { GenericRequest } from '../genericrequest';


export interface PresentationExchangeStartResponse {
    correlationId: string;
    presentationDefinitionId: string;
    presentationRequestUri: string;
    presentationStatusUri: string;
    qrImage: string;
}

export interface PresentationExchangeRequest {
    loadExecuted: boolean;
    loading: boolean;
    error: string | undefined;
    errorCode: string | undefined;
    startResponse: PresentationExchangeStartResponse | undefined;
    genericRequest: GenericRequest | undefined;
}

export const defaultPresentationExchangeState: PresentationExchangeRequest = {
    loadExecuted: false,
    loading: false,
    error: undefined,
    errorCode: undefined,
    startResponse: undefined,
    genericRequest: undefined
}


export interface PresentationExchangeState extends PresentationExchangeRequest {
}

export const presentationExchangeSlice = createSlice({
    name: 'presentationExchange',
    initialState: defaultPresentationExchangeState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(startPresentationExchange.pending.type, (state: PresentationExchangeState, action) => {
            return {
                ...state,
                loading: true,
                error: undefined,
                errorCode: undefined
            };
        });
        builder.addCase(startPresentationExchange.fulfilled.type, (state: PresentationExchangeState, action: any) => {
            return {
                ...state,
                loadExecuted: true,
                loading: false,
                error: undefined,
                errorCode: undefined,
                startResponse: Object.assign({}, action.payload)
            };
        });
        builder.addCase(startPresentationExchange.rejected.type, (state: PresentationExchangeState, action: any) => {
            return {
                ...state,
                loadExecuted: true,
                loading: false,
                error: getErrorMessageFromMessage(action.error.message),
                errorCode: getErrorCodeFromMessage(action.error.message),
            };
        });
        addGenericRequestBuilder(builder, receiveCredentials);
    },
});


const addGenericRequestBuilder = (builder: ActionReducerMapBuilder<any>, service: AsyncThunk<any, any, any>) => {
    builder.addCase(service.pending.type, (state: PresentationExchangeState, action) => {
        return {
            ...state,
            loading: true,
            error: undefined,
            errorCode: undefined
        };
    });
    builder.addCase(service.fulfilled.type, (state: PresentationExchangeState, action: any) => {
        return {
            ...state,
            loadExecuted: true,
            loading: false,
            error: undefined,
            errorCode: undefined,
            genericRequest: Object.assign({}, action.payload)
        };
    });
    builder.addCase(service.rejected.type, (state: PresentationExchangeState, action: any) => {
        return {
            ...state,
            loadExecuted: true,
            loading: false,
            error: getErrorMessageFromMessage(action.error.message),
            errorCode: getErrorCodeFromMessage(action.error.message),
        };
    });
}
